module.exports = __webpack_public_path__ + "img/imagem2.2ed4afd2.jpeg";